import BaseCommand from "@/models/api/commands/BaseCommand";

export class UndoCommand extends BaseCommand {
  CommandName = "Undo";
  Command = null;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
